import { useCallback, useSyncExternalStore } from 'react';
import type { InteractionState } from '../types';
import type { GridInteractionStore } from './gridInteractionStore';

export function useGridInteractionState<Value>(
    store: GridInteractionStore,
    selector: (state: InteractionState) => Value,
): Value {
    const subscribe = useCallback(
        (listener: () => void) => store.subscribe(listener),
        [store],
    );
    const getSnapshot = useCallback(
        () => selector(store.getSnapshot()),
        [selector, store],
    );

    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
